import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Post } from '@cms/interfaces/post';
import { Observable } from 'rxjs';

@Component({
  name: 'bpc-post-single',
})
export default class PostSingle extends Vue {
  @Prop(String) readonly alias: string;

  public loading: boolean = false;
  public postSubscription = null;
  public post: Post = null;

  created() {
    if (this.alias) {
      this.getEntity();
    }
  }

  public getEntity(): void {
    this.loading = true;

    if (this.postSubscription) {
      this.postSubscription.unsubscribe();
    }

    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('post', 'raw')}/details/${
      this.alias
    }`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(
      fetchEntityPath,
      {},
      'public',
    );

    this.postSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.post = res.data;
      },
      error => {
        this.loading = false;
        console.log(error);
      },
      () => {
        this.loading = false;
      },
    );
  }

  @Watch('alias')
  onChangeAlias() {
    this.getEntity();
  }
}
